import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  Avatar,
  Box,
  Container,
  Grid,
  Paper,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import { baseUrl } from "../../services/AzureStorage";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../../common/RouteConstants";
import Helper from "../../common/Helper";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardCard from "../home/DashboardCard";
export default function ComparePlayersAnthros(props) {
  let navigate = useNavigate();
  const useStyles = makeStyles((theme) => ({
    root: {
      margin: "5px 15px",
      border: "1px solid lightgrey",
      borderRadius: "10px",
      boxShadow: "2px 2px 11px grey inset",
    },
    listItemIcon: {
      minWidth: "38px",
    },
    imageIcon: {
      width: "100%",
      height: "100%",
      cursor: "pointer",
    },
    iconRoot: {
      textAlign: "center",
      width: "100%",
      height: "50px",
    },
    cardStyle: {
      border: "1px solid lightgrey",
      borderRadius: "10px",
      height: "250px",
    },
    headerText: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerText2: {
      marginBottom: theme.spacing(0.5),
      color: "rgb(29, 66, 138)",
    },
    headerTextInfo: {
      color: "rgb(29, 66, 138)",
      fontSize: "14px",
    },
    headerBox: {
      background: "#c1d0ed",
      borderRadius: "17px",
    },
    smBlue: {
      marginLeft: "16px",
      width: 26,
      height: 26,
      color: theme.palette.getContrastText("#0c2c75"),
      backgroundColor: "#1e3f7e",
      position: "relative",
      borderRadius: "50%",
    },
    stickyColumn: {
      position: "sticky",
      background: "white",
      left: 0,
      zIndex: 1,
      paddingRight: theme.spacing(1),
    },
    playerNameStyle: {
      cursor: "pointer",
      "&:hover": {
        color: "blue",
      },
    },
  }));
  const classes = useStyles();
  const {
    favPlayersASAData,
    favPlayersASADataselected,
    playerAnthrosAndStrengthAgiltyColumns,
    Showval,
    notes,
    loading,
    bodyFat,
    handDimentions,
    weight,
    heightWithShoes,
    heightWithoutShoes,
    standingReach,
    wingSpanDimentions,
    eventId,
  } = props;

  var newplayerAnthrosAndStrengthAgiltyColumns = [];

  playerAnthrosAndStrengthAgiltyColumns &&
    playerAnthrosAndStrengthAgiltyColumns.map((val, index) => {
      if (
        val.id === "playerName" ||
        val.id === "position" ||
        val.id === "collegeOrClub" ||
        val.id === "bodyFat" ||
        val.id === "handLength" ||
        val.id === "bodyWeight" ||
        val.id === "heightWithShoesFeet" ||
        val.id === "heightWithOutShoesFeet" ||
        val.id === "standingReachFeet" ||
        val.id === "wingSpanFeet"
      ) {
        newplayerAnthrosAndStrengthAgiltyColumns.push({
          id: val.id,
          headerName: val.headerName,
        });
      }
    });
  const [order, setOrder] = React.useState("asc");

  const [orderBy, setOrderBy] = React.useState("playerName");

  const handleSortRequest = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  function getComparator(sortOrder, sortOrderBy) {
    return (a, b) => descendingComparator(a, b, sortOrder, sortOrderBy);
  }
  function descendingComparator(a, b, sortOrder, sortOrderBy) {
    if (a[sortOrderBy] === b[sortOrderBy]) {
      return 0;
    } else if (sortOrder === "asc") {
      return a[sortOrderBy] < b[sortOrderBy] ? -1 : 1;
    } else {
      return a[sortOrderBy] < b[sortOrderBy] ? 1 : -1;
    }
  }

  const viewPlayerProfile = (playerId) => {
    navigate(`/${eventId}${RouteConstants.VIEW_PLAYER_PROFILE}/${playerId}`, {
      state: { from: "CombineResults", tab: 0 },
    });
  };

  return (
    <Container maxWidth={false}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Anthropometry
              </Typography>
            </Box>
          </Box>
          <Grid container spacing={2} pt={3}>
            <TableContainer>
              {favPlayersASAData && favPlayersASAData.length > 0 && (
                <Table>
                  <TableHead>
                    {newplayerAnthrosAndStrengthAgiltyColumns.map((elem, i) => {
                      return (
                        <TableCell
                          className={
                            elem.id === "playerName"
                              ? classes.stickyColumn
                              : classes.na
                          }
                          sx={{
                            padding: "4px",
                            paddingLeft:
                              elem.id === "playerName" ? "25px" : "0px",
                          }}
                        >
                          <TableSortLabel
                            active={orderBy === elem.id}
                            direction={orderBy === elem.id ? order : "asc"}
                            onClick={(e) => handleSortRequest(e, elem.id)}
                          >
                            {elem.headerName}
                            {orderBy === elem.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      );
                    })}
                  </TableHead>
                  <TableHead>
                    <TableCell className={classes.stickyColumn}></TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                    <TableCell>(%)</TableCell>
                    <TableCell>(length | width)</TableCell>
                    <TableCell>(lbs)</TableCell>
                    <TableCell>(ft' in")</TableCell>
                    <TableCell>(ft' in")</TableCell>
                    <TableCell>(ft' in")</TableCell>
                    <TableCell>(ft' in")</TableCell>
                  </TableHead>
                  <TableBody>
                    {Showval
                      ? favPlayersASADataselected
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow>
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "5px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      {val.playerName}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.position ? val.position : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.collegeOrClub ? val.collegeOrClub : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.bodyFat ? val.bodyFat : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.handLength} | {val.handWidth}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.bodyWeight}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.heightWithShoesFeet}'{" "}
                                  {val.heightWithShoesInches}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.heightWithOutShoesFeet}'{" "}
                                  {val.heightWithOutShoesInches}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.standingReachFeet}'{" "}
                                  {val.standingReachInches}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.wingSpanFeet}'{val.wingSpanInches}'
                                </TableCell>
                              </TableRow>
                            );
                          })
                      : favPlayersASAData
                          .slice()
                          .sort(getComparator(order, orderBy))
                          .map((val, index) => {
                            return (
                              <TableRow>
                                <TableCell
                                  className={classes.stickyColumn}
                                  sx={{ padding: "4px" }}
                                >
                                  <Box display="flex">
                                    {val.headshotURL &&
                                    val.headshotURL !== "" ? (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        src={
                                          val.headshotURL
                                            ? baseUrl(val.headshotURL)
                                            : ""
                                        }
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    ) : (
                                      <Avatar
                                        className={classes.smBlue}
                                        sx={{
                                          bgcolor: "#1d428a",
                                          cursor: "pointer",
                                        }}
                                        alt="basketball"
                                        title="View Player Profile"
                                        onClick={() =>
                                          viewPlayerProfile(val.playerID)
                                        }
                                      >
                                        <Typography variant="caption">
                                          {Helper.GetNameInitials(
                                            `${val.playerName}`
                                          )}
                                        </Typography>
                                      </Avatar>
                                    )}
                                    &nbsp;&nbsp;
                                    <Typography
                                      variant="body2"
                                      className={classes.playerNameStyle}
                                      title="View Player Profile"
                                      onClick={() =>
                                        viewPlayerProfile(val.playerID)
                                      }
                                    >
                                      {val.playerName}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.position ? val.position : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.collegeOrClub ? val.collegeOrClub : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.bodyFat ? val.bodyFat : "-"}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.handLength} | {val.handWidth}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.bodyWeight}
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.heightWithShoesFeet}'{" "}
                                  {val.heightWithShoesInches}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.heightWithOutShoesFeet}'{" "}
                                  {val.heightWithOutShoesInches}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.standingReachFeet}'{" "}
                                  {val.standingReachInches}"
                                </TableCell>
                                <TableCell style={{ padding: "4px" }}>
                                  {val.wingSpanFeet}'{val.wingSpanInches}''
                                </TableCell>
                              </TableRow>
                            );
                          })}
                  </TableBody>
                </Table>
              )}
            </TableContainer>
          </Grid>
        </Paper>
      </Box>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ p: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            flexDirection="row"
            className={classes.headerBox}
          >
            <Box display="flex" pl={2}>
              <Typography className={`${classes.headerText} headerTitle`}>
                Anthropometry Leader Boards
              </Typography>
            </Box>
            <Box display="flex" pl={2}>
              {notes &&
                notes.length > 0 &&
                notes.find(
                  (x) =>
                    x.childName.replace(/\s/g, "").toLowerCase() ===
                    "Anthropometrics".toLowerCase()
                ).isActive && (
                  <>
                    {/* <InfoOutlinedIcon style={{ color: "#fff" }} /> */}
                    <Typography
                      // className="subtitle2"
                      className={classes.headerTextInfo}
                    >
                      {
                        notes.find(
                          (x) =>
                            x.childName.replace(/\s/g, "").toLowerCase() ===
                            "Anthropometrics".toLowerCase()
                        ).description
                      }
                    </Typography>
                  </>
                )}
            </Box>
          </Box>

          {loading && (
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          )}

          <Grid container spacing={2} pt={2}>
            <DashboardCard
              title="Body Fat"
              unit="(%)"
              data={bodyFat}
              value="101"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />

            <DashboardCard
              title="Hand Dimensions"
              data={handDimentions}
              unit="length(in)|width(in)"
              value="102"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />

            <DashboardCard
              title="Weight"
              unit="(lbs)"
              data={weight}
              value="103"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />

            <DashboardCard
              title="Height With Shoes"
              unit={`(ft' in")`}
              data={heightWithShoes}
              value="104"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />

            <DashboardCard
              title="Height W/o Shoes"
              data={heightWithoutShoes}
              unit={`(ft' in")`}
              value="105"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />

            <DashboardCard
              title="Standing Reach"
              data={standingReach}
              unit={`(ft' in")`}
              value="106"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />

            <DashboardCard
              title="Wingspan Dimensions"
              data={wingSpanDimentions}
              unit={`(ft' in")`}
              value="107"
              from="CombineResults"
              tab={0}
              eventId={eventId}
            />
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
